import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBAq67GcQBo3E0IbDB6MwPXR2DqCuVyfc8",
  authDomain: "filmweb-6478d.firebaseapp.com",
  projectId: "filmweb-6478d",
  storageBucket: "filmweb-6478d.appspot.com",
  messagingSenderId: "188905178487",
  appId: "1:188905178487:web:5392c7b64592f3da1f4d72",
  measurementId: "G-PTTQXV748V",
};

firebase.initializeApp(firebaseConfig);

const projectFirestore = firebase.firestore();
const projectAuth = firebase.auth()
const projectStorage = firebase.storage()

const timestamp = firebase.firestore.FieldValue.serverTimestamp

export { projectFirestore, projectAuth, projectStorage, timestamp }
